var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminLive',{attrs:{"admin":this.recruiter}},[_c('div',{staticStyle:{"height":"100vh"},attrs:{"id":"meet"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }